export default __webpack_public_path__ + "src/_images/file_map_stack.png";